import { Report } from 'app/providers/storage-api/report.service';
import { WidgetDataSource } from '../../../../../models';
import { TopicScoringWidgetOptions } from '../../../components/widget-topic-scoring/widget-topic-scoring.component';
import { AbstractChartReport } from '../chart-report-abstract/chart-report-abstract';

export interface TopicScoringData {
  toFind: number;
  found: number;
  foundCorrectly: number;
  precision: number;
  recall: number;
  f1: number;
  incorrect: number;
  missing?: number;
}

export class TopicScoringReport extends AbstractChartReport {
  public static KEY = '__key__';

  reportName = 'featureDocAccuracy';

  reportHandler = (_dashboard, _widget, _response, _options) => {
    return {};
  };

  getFields() {
    return ['limit'];
  }

  isAnalyticItemSupported(analyticItem) {
    return analyticItem === 'features';
  }

  public canHideItems(): boolean {
    return true;
  }

  canSort() {
    return false;
  }

  public canSetChartMaximum(): boolean {
    return false;
  }

  public async executeReportForTopicScoring(
    filterQuery: string,
    payload: TopicScoringWidgetOptions,
    customField: string,
    widgetDataSource: WidgetDataSource,
    format: 'json' | 'csv' = 'json',
    limit?: number
  ): Promise<TopicScoringData[]> {
    const params = await this.getParams();

    params.customField = customField;
    params.analysisName = widgetDataSource.analysisId;

    if (payload.selectedItems && payload.selectedItems.length) {
      params.featureIncludes = JSON.stringify(payload.selectedItems);
    } else {
      params.featureSize = limit || this.options.limit;
    }

    if (payload.excludedValues) {
      const rowExcludes = payload.excludedValues.map((item) => item.name);
      params.featureExcludes = JSON.stringify(rowExcludes);
    }

    delete params.excludedValues;
    delete params.selectedItems;
    delete params.topN;
    delete params.featureName;
    delete params.entityTypeFilter;
    delete params.sentimentScale;
    delete params.standardField;

    const response = await this.reportService.getReport(
      widgetDataSource.collectionName,
      widgetDataSource.groupId,
      this.reportName,
      params,
      format,
      filterQuery,
      this.filterService.buildFilterStringClearPolarityFilters(
        this.options.filters,
        this.options.analyticItem
      ),
      undefined,
      this.options.projectId
    );

    this.lastDocumentCount = (<Report>response).totalHits;

    return this.processResponse((<Report>response).items);
  }

  public async processResponse(reportItems, _filterQuery?: string): Promise<any> {
    return Object.keys(reportItems)
      .filter((key) => key !== '__metadata__')
      .map((key) => ({
        [TopicScoringReport.KEY]: key,
        incorrect: reportItems[key].found - reportItems[key].foundCorrectly,
        missing: reportItems[key].toFind - reportItems[key].foundCorrectly,
        ...reportItems[key],
      }));
  }
}
